// src/services/propositions.js — PROFILS PROPOSÉS : le paquet de la personne
// connectée, et les trois gestes du tri. Un seul endroit qui parle au
// serveur ; chaque écran affiche son message tel quel.
import APIService from './api';

const BASE = 'https://besoins-tat-production.up.railway.app';
const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });
const jsonH = () => ({ ...authH(), 'Content-Type': 'application/json' });
const absente = (r, j) => r.status === 501 || (r.status === 404 && j.success !== false);
const ABSENTE = 'Les profils proposés arrivent côté serveur.';

export async function lirePaquet(besoinId = null) {
  try {
    const r = await fetch(`${BASE}/propositions${besoinId ? `?besoin_id=${encodeURIComponent(besoinId)}` : ''}`, { headers: authH() });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: ABSENTE };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, paquets: Array.isArray(j.paquets) ? j.paquets : [], total: j.total_a_trier || 0, motifs: Array.isArray(j.motifs) ? j.motifs : [], max: j.paquet_max || 20 };
  } catch (e) { return { ok: false, error: e.message }; }
}

async function geste(id, quoi, corps = null) {
  try {
    const r = await fetch(`${BASE}/propositions/${id}/${quoi}`, { method: 'POST', headers: jsonH(), body: JSON.stringify(corps || {}) });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: ABSENTE };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})`, champ: j.champ };
    return { ok: true, data: j.data, message: j.data?.message || 'Fait.' };
  } catch (e) { return { ok: false, error: e.message }; }
}
export const deciderInteressant = (id) => geste(id, 'decider', { decision: 'interessant' });
export const deciderPasInteressant = (id, motif) => geste(id, 'decider', { decision: 'pas_interessant', motif });
export const reporterProposition = (id) => geste(id, 'reporter');
export const annulerProposition = (id) => geste(id, 'annuler');

/** Depuis une campagne : proposer un paquet à une personne. */
export async function proposerProfils(taskId, { recruiterIds = [], tous = false, proposeA, note = '' }) {
  try {
    const r = await fetch(`${BASE}/sourcing/${taskId}/proposer`, { method: 'POST', headers: jsonH(), body: JSON.stringify({ recruiter_ids: recruiterIds, tous, propose_a: proposeA, note: note || null }) });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: 'Proposer des profils arrive côté serveur.' };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, message: j.message || 'Profils proposés.', proposes: j.proposes, ecartes: j.ecartes || [] };
  } catch (e) { return { ok: false, error: e.message }; }
}
